<template>
  <v-dialog v-model="dialog" max-width="620" persistent>
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>
    <v-dialog v-model="deleteDialog" max-width="480">
      <v-card>
        <v-card-title
          >Är du säker på att du vill radera beslutspunkt "{{
            decisionPoint.text
          }}"?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">Nej</v-btn>
          <v-btn text color="primary" type="submit" @click="remove">Ja</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-card-title class="color-a">
        Redigerar beslutspunkt "{{ decisionPoint.text }}"
      </v-card-title>
      <v-card-text>
        <decision-point-form
          ref="form"
          :decisionPoint="decisionPoint"
          :weightedVoteOptional="weightedVoteOptional"
        ></decision-point-form>
        <v-btn text @click="deleteDialog = true"
          ><v-icon left>mdi-delete</v-icon> Radera beslutspunkt</v-btn
        >
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Avbryt</v-btn>
        <v-btn text color="primary" type="submit" @click="save">Spara</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DecisionPointForm from "@/components/decisionPoints/DecisionPointForm.vue";

export default {
  props: {
    meetingId: String,
    decisionPoint: Object,
    weightedVoteOptional: Boolean
  },
  components: { DecisionPointForm },
  data() {
    return {
      dialog: false,
      deleteDialog: false
    };
  },
  computed: {},
  methods: {
    close() {
      this.dialog = false;
    },
    async save() {
      var payload = {
        meetingId: this.meetingId,
        pointId: this.decisionPoint.id,
        ...this.$refs.form.form
      };
      if (this.weightedVoteOptional) {
        payload.weightedVoteOptional = true;
        payload.forceUnweighted = !payload.weightedVote;
      }
      const success = await this.$store.dispatch(
        "meetings/editDecisionPoint",
        payload
      );
      if (success) {
        this.close();
      }
    },
    async remove() {
      const success = await this.$store.dispatch(
        "meetings/deleteDecisionPoint",
        {
          meetingId: this.meetingId,
          pointId: this.decisionPoint.id
        }
      );
      if (success) {
        this.close();
      }
    }
  }
};
</script>

<style></style>
